<div [formGroup]="addressForm">
  <!-- Address -->
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.ADDRESS' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="address"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.ADDRESS' | translate }}"
        [ngStyle]="{'border': (submitted && (addressControl?.hasError('required') || addressControl?.hasError('invalidAddress') || addressControl?.hasError('stripeVerification'))) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
      />
    </div>
    <span
      *ngIf="submitted && (addressControl?.hasError('required') || addressControl?.hasError('invalidAddress') || addressControl?.hasError('stripeVerification'))"
      class="error-message"
    >
      <div *ngIf="addressControl?.hasError('required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="addressControl?.hasError('invalidAddress')">
        {{ 'FORM.ERROR.ADDRESS' | translate }}
      </div>
      <div *ngIf="addressControl?.hasError('stripeVerification')">
        {{ addressControl?.errors?.['stripeVerification'] }}
      </div>
    </span>
  </div>

  <!-- City -->
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.CITY' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="city"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.CITY' | translate }}"
        [ngStyle]="{'border': (submitted && (cityControl?.hasError('required') || cityControl?.hasError('invalidCity') || cityControl?.hasError('stripeVerification'))) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
      />
    </div>
    <span
      *ngIf="submitted && (cityControl?.hasError('required') || cityControl?.hasError('invalidCity') || cityControl?.hasError('stripeVerification'))"
      class="error-message"
    >
      <div *ngIf="cityControl?.hasError('required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="cityControl?.hasError('invalidCity')">
        {{ 'FORM.ERROR.CITY' | translate }}
      </div>
      <div *ngIf="cityControl?.hasError('stripeVerification')">
        {{ cityControl?.errors?.['stripeVerification'] }}
      </div>
    </span>
  </div>

  <!-- Zip Code -->
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.ZIP_CODE' | translate }}*</h1>
    <div class="input-box">
      <input
        type="text"
        formControlName="zip_code"
        class="input"
        placeholder="{{ 'FORM.PLACEHOLDER.ZIP_CODE' | translate }}"
        [ngStyle]="{'border': (submitted && (zipControl?.hasError('required') || zipControl?.hasError('invalidZip') || zipControl?.hasError('stripeVerification') || zipControl?.hasError('postalCodeCityMismatch'))) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        (blur)="onFieldBlur('zip_code')"
      />
    </div>
    <div
      *ngIf="submitted && (zipControl?.hasError('required') || zipControl?.hasError('invalidZip') || zipControl?.hasError('stripeVerification') || zipControl?.hasError('postalCodeCityMismatch'))"
      class="error-message"
    >
      <div *ngIf="zipControl?.hasError('required')">
        {{ 'FORM.ERROR.REQUIRED' | translate }}
      </div>
      <div *ngIf="zipControl?.hasError('invalidZip')">
        {{ 'FORM.ERROR.ZIP_CODE' | translate }}
      </div>
      <div *ngIf="zipControl?.hasError('stripeVerification')">
        {{ zipControl?.errors?.['stripeVerification'] }}
      </div>
      <div *ngIf="zipControl?.hasError('postalCodeCityMismatch')">
        <span *ngIf="zipControl?.errors?.['geographicError']">
          {{ zipControl?.errors?.['geographicError'] }}
        </span>
        <span *ngIf="!zipControl?.errors?.['geographicError']">
          Le code postal ne correspond pas à la ville indiquée
        </span>
      </div>
    </div>
  </div>
</div>
